export default () => {
  const init = () => {
    customElements.define("form-registration", FormRegistration);
  };
  init();
};

class FormRegistration extends HTMLElement{
  constructor() {
    super();
    this.validateEmail = this.validateEmail.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.validateRegisterForm = this.validateRegisterForm.bind(this);
    this.validateFirstName = this.validateFirstName.bind(this);
    this.validateLastName = this.validateLastName.bind(this);
    this.handleCheckboxToggle = this.handleCheckboxToggle.bind(this);
    this.translations = window.SS.Strings.errorsMessage;
  }
  
  connectedCallback(){
    this.form = this.querySelector('#register-form') || null;
    this.emailInput = this.querySelector('#RegisterForm-email') || null;
    this.passwordInput = this.querySelector('#RegisterForm-password') || null;
    this.firstName = this.querySelector('#RegisterForm-FirstName') || null;
    this.lastName = this.querySelector('#RegisterForm-LastName') || null;
    this.emailError = this.querySelector('#emailError') || null;
    this.passwordError = this.querySelector('#passwordError') || null;
    this.lastNameError = this.querySelector('#lastNameError') || null;
    this.firstNameError = this.querySelector('#firstNameError') || null;
    this.checkboxMark = this.querySelector('.checkbox-mark') || null;
    this.checkboxCustom = this.querySelector('.custom-checkbox') || null;
    this.setEventListeners();
    this.handleCheckboxToggle();
  }

  disconnectedCallback() {
    this.emailInput.removeEventListener('input', this.validateEmail);
    this.passwordInput.removeEventListener('input', this.validatePassword);
    this.firstName.removeEventListener('input', this.validateFirstName);
    this.lastName.removeEventListener('input', this.validateLastName);
    this.form.removeEventListener('submit', this.validateRegisterForm);
  }

  setEventListeners() {
    this.emailInput.addEventListener('input', () => this.validateEmail());
    this.passwordInput.addEventListener('input', () => this.validatePassword());
    this.firstName.addEventListener('input', () => this.validateFirstName());
    this.lastName.addEventListener('input', () => this.validateLastName());
    this.form.addEventListener('submit', (e) => this.validateRegisterForm(e));
  }

  validateInput(inputElement, validationFunction, errorElement, errorMessage) {
    const isValid = validationFunction(inputElement.value.trim());
    const elementError = errorElement;
    let errorElementText = '';
  
    if (!isValid) {
      errorElementText = errorMessage;
      inputElement.classList.add('error-message');
    } else {
      inputElement.classList.remove('error-message');
    }

    elementError.textContent = errorElementText;
    return isValid;
  }

  validateEmail() {
    this.validateInput(
      this.emailInput,
      (value) => {
        const regex = /^\S+@\S+\.\S+$/;
        return regex.test(value) && value.length > 0;
      },
      this.emailError,
      this.translations.emailErrorMessage
    );
  }

  validatePassword() {
    this.validateInput(
      this.passwordInput,
      (value) => value.length >= 5,
      this.passwordError,
      this.translations.passwordErrorMessage
    );
  }

  validateFirstName() {
    this.validateInput(
      this.firstName,
      (value) => value.length > 0,
      this.firstNameError,
      this.translations.firstNameErrorMessage
    );
  }

  validateLastName() {
    this.validateInput(
      this.lastName,
      (value) => value.length > 0,
      this.lastNameError,
      this.translations.lastNameErrorMessage
    );
  }

  validateRegisterForm(e) {
    e.preventDefault();

    const isEmailValid = this.validateEmail();
    const isPasswordValid = this.validatePassword();
    const isFirstNameValid = this.validateFirstName();
    const isLastNameValid = this.validateLastName();

    if (isEmailValid && isPasswordValid && isFirstNameValid && isLastNameValid) {
      this.form.submit();
    }
  }

  handleCheckboxToggle() {
    this.checkboxCustom.addEventListener('click', () =>{
      if (this.checkboxMark.classList.contains('hidden')){
        this.checkboxMark.classList.remove('hidden');
        this.checkboxMark.classList.add('inline-block');
      } else {
        this.checkboxMark.classList.add('hidden');
        this.checkboxMark.classList.remove('inline-block');
      }
    });
  }
};